export function BugsnagFallback({ clearError }) {
  return (
    <main className="flex min-h-screen items-center justify-center bg-brand-surface px-5 py-10">
      <section className="w-full max-w-xl rounded-[2rem] border border-brand-primary/10 bg-white/90 p-8 shadow-soft sm:p-10">
        <p className="text-xs font-semibold uppercase tracking-[0.35em] text-brand-primary/70">
          Penca OSU
        </p>
        <h1 className="mt-4 font-serif text-3xl leading-tight text-brand-primary sm:text-4xl">
          Ocurrió un problema inesperado
        </h1>
        <p className="mt-4 max-w-lg text-sm leading-6 text-black/70 sm:text-base">
          Estamos registrando el error y podés intentar volver a cargar la pantalla para seguir
          navegando.
        </p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <button
            type="button"
            onClick={clearError}
            className="inline-flex items-center justify-center rounded-full bg-brand-primary px-5 py-3 text-sm font-semibold text-white transition hover:bg-brand-secondary"
          >
            Reintentar
          </button>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="inline-flex items-center justify-center rounded-full border border-brand-primary/15 bg-white px-5 py-3 text-sm font-semibold text-brand-primary transition hover:border-brand-primary/30 hover:bg-brand-primary/5"
          >
            Recargar página
          </button>
        </div>
      </section>
    </main>
  );
}
